"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _GridAreaContainer = _interopRequireDefault(require("@sprinx/react-mui-components/GridAreaContainer"));

var _useShoppingRegion = _interopRequireDefault(require("../../../shop/useShoppingRegion"));

var _ProductDetailAdornment = _interopRequireDefault(require("./ProductDetailAdornment"));

// import useTranslate from '@sprinx/react-globalize/useTranslate';
var useStyles = (0, _styles.makeStyles)(function () {
  return (
    /* theme */
    {
      root: {
        display: 'flex',
        flexWrap: 'wrap'
      }
    }
  );
}, {
  name: 'ProductDetailAdornmentsPromo'
});

function ProductDetailAdornmentsPromo(_ref) {
  var AdornmentProps = _ref.AdornmentProps,
      pClasses = _ref.classes,
      className = _ref.className,
      product = _ref.product,
      renderToGridArea = _ref.renderToGridArea,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["AdornmentProps", "classes", "className", "product", "renderToGridArea"]);
  var classes = useStyles({
    classes: pClasses
  });
  var region = (0, _useShoppingRegion.default)();
  var _product$extra$sticke = product.extra.stickers,
      stickers = _product$extra$sticke === void 0 ? [] : _product$extra$sticke;
  return /*#__PURE__*/_react.default.createElement(_GridAreaContainer.default, (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, className),
    renderToGridArea: renderToGridArea
  }), stickers.filter(function (a) {
    return a.label && a.bgColor && a.textColor && a.language === region;
  }).map(function (a, index) {
    return /*#__PURE__*/_react.default.createElement(_ProductDetailAdornment.default, (0, _extends2.default)({}, AdornmentProps, {
      key: index.toString(),
      style: {
        color: a.textColor,
        backgroundColor: a.bgColor
      }
    }), a.label);
  }));
}

process.env.NODE_ENV !== "production" ? ProductDetailAdornmentsPromo.propTypes = {
  AdornmentProps: _propTypes.default.shape({}),
  classes: _propTypes.default.shape({
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  product: _propTypes.default.shape({
    extra: _propTypes.default.shape({
      stickers: _propTypes.default.array
    })
  }),
  renderToGridArea: _propTypes.default.string
} : void 0;
ProductDetailAdornmentsPromo.defaultProps = {
  AdornmentProps: undefined,
  classes: undefined,
  className: undefined,
  product: undefined,
  renderToGridArea: 'adornments'
};
var _default = ProductDetailAdornmentsPromo;
exports.default = _default;